<template>
<div>
      <div class="vx-row">
        <!-- MULTIPLE COLUMNS-->
        <div class="vx-col w-3/4 mb-base">
          <vx-card title="">
            <div class="demo-alignment">
              <v-select :value="selected" v-model="selected" @input="ps"  :options="options" style="width:220px"></v-select>
              
              <vs-input class="inputx" placeholder="Barkod" @keyup.enter="barkodOku(0)" id="barkodM" :ref="barkod" v-model="barkod" />

              <label>Askıdaki Ürünleri Dahil Et</label><vs-switch v-model="askiDurumu" />
            </div>
            <div class="demo-alignment">
                <vs-button @click="secilenPartiUrunleri()" color="success" type="filled">İade Listesi</vs-button>
               
                <vs-button @click="listeTemizle()" color="dark" type="filled">Liste Temizle</vs-button>
            </div>
          </vx-card>



          <vx-card title="" style="margin-top:10px;">
          <vs-table :data="sipariseGoreUrunListesi">
        <template slot="thead">
          <vs-th>Resim</vs-th>
          <vs-th  sort-key="stokkodu">Stok Kodu</vs-th>
          <vs-th  sort-key="stokkodu">Barkod</vs-th>
          <vs-th>Stok Adı</vs-th>
          <vs-th>Sipariş Adeti</vs-th>
          <vs-th>Eklenen</vs-th>
          <vs-th>Durum</vs-th>
        </template>

          <template slot-scope="{data}">
            <vs-tr state="" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <vs-button color="success" type="flat" icon-pack="feather" icon="icon-camera" @click="imageShow(data[indextr].merchantSku)"></vs-button>
              </vs-td>
              <vs-td :data="data[indextr].merchantSku">
                {{ data[indextr].merchantSku }}
              </vs-td>
              <vs-td :data="data[indextr].barcode">
                {{ data[indextr].barcode }}
              </vs-td>
              <vs-td :data="data[indextr].stokAdi">
                {{ data[indextr].stokAdi }}
              </vs-td>
              <vs-td :data="data[indextr].quantity">
                {{ data[indextr].quantity }}
              </vs-td>
              <vs-td :data="data[indextr].eklenen">
               {{ data[indextr].eklenen }}
              </vs-td>
              <vs-td  :data="data[indextr].durum">
              
              <div v-if="data[indextr].quantity===data[indextr].eklenen" class="con-vs-chip product-order-status vs-chip-success con-color" style="color: rgba(255, 255, 255, 0.9);">
                <span class="text-chip vs-chip--text">Tamamlandı</span>
              </div>
              </vs-td>
            </vs-tr>

            <vs-tr>
              <vs-td>
                
              </vs-td>
              <vs-td >
               
              </vs-td>
              <vs-td >
               
              </vs-td>
              <vs-td >
               
              </vs-td>
              <vs-td >
                             </vs-td>
              <vs-td >
               
              </vs-td>
            </vs-tr>
          </template>

      </vs-table>
      </vx-card>

        </div>

        <div class="vx-col w-1/4 mb-base">
      <vx-card>
                            <p class="text-grey mb-3">Sipariş Detayları</p>
                            <div class="flex justify-between">
                                <span class="font-semibold">Sipariş No</span>
                                <span class="font-medium text-danger cursor-pointer">{{genelSiparisNo}}</span>
                            </div>
                             <div class="flex justify-between">
                                <span class="font-semibold">Fatura No</span>
                                <span class="font-medium text-danger cursor-pointer">{{genelSiparisNo}}</span>
                            </div>
                            
                            <div class="flex justify-between">
                                <span class="font-semibold">Kargo</span>
                                <span class="font-medium text-danger cursor-pointer">{{genelKargoAdi}}</span>
                            </div>

                            <div class="flex justify-between">
                                <span class="font-semibold">Kargo Numarası</span>
                                <span class="font-medium text-danger cursor-pointer">{{genelKargoNo}}</span>
                            </div>

                            <div class="flex justify-between">
                                <span class="font-semibold">Müşteri</span>
                                <span class="font-medium text-danger cursor-pointer">{{genelMusteri}}</span>
                                <span v-if="hediyeMi == '1'">
                               (Hediye Paketi)
                                </span>
                            </div>

                           

                          
                             <div class="flex justify-between mb-2">
                                <span class="text-grey">Toplam ₺</span>
                                <span>{{genelToplam}}</span>
                            </div>
                            
                            <vs-divider />
                            <div class="flex justify-between mb-2">
                            <vs-button :disabled="validated == 1" id="button-with-loading"  class="w-full vs-con-loading__container" @click="faturaOlustur()" style="height:70px">İade Oluştur</vs-button>
                            </div>
                            <div class="flex justify-between mb-2">
                            <vs-button  class="w-full" @click="faturaCikti()" color="red" style="height:70px">Fatura Çıktısı</vs-button>
                            </div>
 


                           


                            <div class="" style="display:inline"><img :src="'data:image.png;base64,' + imageLink" style="width:100%"></div>
                            <div class="" style="display:none"><img :src="imageLink" style="width:100%"></div>
                        </vx-card>

                       
                            
                       
    </div>
      </div>
    
<div class="vx-row">
    <!-- MULTIPLE COLUMNS-->

    <div class="vx-col w-3/4 mb-base">
      
    </div>



    


        <div class="vx-col w-1/4 mb-base">
          <vx-card title="">
            
          </vx-card>
        </div>
  </div>

     
        <vs-popup fullscreen  class="holamundo" title="Seçilen Parti Ürünleri" :active.sync="popupActive">
              <table>
                <tr>
                  <td><vs-button @click="print()" color="success" type="filled">Çıktı Al</vs-button></td>
                </tr>
              </table>
              <div  id="printMe">
              <vs-table :data="list">
                
                <template slot="thead">
                  <vs-th style="border:1px solid #000000; padding:12px"  sort-key="stokkodu">Resim</vs-th>
                  <vs-th style="border:1px solid #000000; padding:12px"  sort-key="stokkodu">Sipariş Yeri</vs-th>
                  <vs-th style="border:1px solid #000000; padding:12px"  sort-key="stokkodu">Stok Kodu</vs-th>
                  <vs-th style="border:1px solid #000000; padding:12px"  sort-key="stokkodu">Stok Adı</vs-th>
                
                  <vs-th style="border:1px solid #000000; padding:12px">Sipariş Adet</vs-th>
                  <vs-th style="border:1px solid #000000; padding:12px">Depo Adet</vs-th>
                  <vs-th style="border:1px solid #000000; padding:12px">Sipariş Tarihleri</vs-th>
                </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" style="border:1px solid #000000">
                      <vs-td  style="border:1px solid #000000">
                        <img :src="data[indextr].resim" width="100">
                      </vs-td>
                      <vs-td  style="border:1px solid #000000">
                        {{pazaryeriVal}}- {{partiVal}}
                      </vs-td>
                      <vs-td :data="data[indextr].urunKodu" style="border:1px solid #000000">
                        {{ data[indextr].urunKodu }}
                      </vs-td>
                      <vs-td :data="data[indextr].stokAdi" style="border:1px solid #000000">
                        {{ data[indextr].stokAdi }}
                      </vs-td>
                      
                      <vs-td :data="data[indextr].siparisAdet" style="border:1px solid #000000; text-align:center">
                        {{ data[indextr].siparisAdet }}
                      </vs-td>
                      <vs-td :data="data[indextr].depoAdet" style="border:1px solid #000000; text-align:center">
                        {{ data[indextr].depoAdet }}
                      </vs-td>
                      <vs-td :data="data[indextr].depoAdet" style="border:1px solid #000000; text-align:center">
                        {{ data[indextr].orderDate }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td  style="border:1px solid #000000; text-align:center"></vs-td>
                      <vs-td  style="border:1px solid #000000; text-align:center"></vs-td>
                      <vs-td  style="border:1px solid #000000; text-align:right">Toplam Parça</vs-td>
                      <vs-td  style="border:1px solid #000000; text-align:center">{{total}}</vs-td>
                      <vs-td  style="border:1px solid #000000; text-align:center"></vs-td>
                    </vs-tr>
                  </template>

              </vs-table>
              </div>
        </vs-popup>

        <vs-popup fullscreen  class="holamundo" title="Seçilen Parti Ürünleri" :active.sync="popupActiveSiparis">
          <table>
            <tr>
              <td><vs-input class="inputx" placeholder="Sipariş Numarası" @keyup.enter="siparisBul()" :ref="siparisBulOrderNumber" v-model="siparisBulOrderNumber" /></td>
            </tr>
          </table>
              <vs-table :data="listSiparis">
                <template slot="thead">
                  <vs-th  sort-key="stokkodu">Sipariş No</vs-th>
                  <vs-th  sort-key="stokkodu">Müşteri Ad Soyad</vs-th>
                  <vs-th  sort-key="stokkodu">Kargo No</vs-th>
                  <vs-th>Tutar</vs-th>
                  <vs-th>Seç</vs-th>
                  <vs-th>Sil</vs-th>
                </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].orderNumber">
                        {{ data[indextr].orderNumber }}
                      </vs-td>
                      <vs-td :data="data[indextr].invoiceFirstName">
                        {{ data[indextr].invoiceFirstName }} {{ data[indextr].invoiceLastName }}
                      </vs-td>
                      <vs-td :data="data[indextr].cargoTrackingNumber">
                        {{ data[indextr].cargoTrackingNumber }}
                      </vs-td>
                      <vs-td :data="data[indextr].grossAmount">
                        {{ data[indextr].grossAmount }}
                      </vs-td>
                      <vs-td>
                        <span v-if="data[indextr].islem == '0'">
                      <vs-button @click="siparisHazirla(data[indextr].orderNumber,data[indextr].merchantSku,data[indextr].partiNo)" color="success" type="filled">Seç</vs-button>
                        </span>
                      <span v-if="data[indextr].islem == '1'">
                        <vs-button  @click="tekrarIslemeAl(data[indextr].orderNumber,data[indextr].merchantSku,data[indextr].partiNo)" color="warning" type="filled">Tekrar İşleme Al</vs-button>
                      </span>
                      </vs-td>

                       <vs-td>
                        
                        <vs-button  @click="secilenSiparisSil(data[indextr].orderNumber)" color="red" type="filled">Sil</vs-button>
                      
                      </vs-td>

                    </vs-tr>
                  </template>

              </vs-table>
        </vs-popup>

        <vs-popup fullscreen  class="holamundo" title="Seçilen Parti Ürünleri" :active.sync="popupActiveCikti">
              
                
              <vs-table :data="ciktiListesi">
                
                
                <template slot="thead">
                  <vs-th  sort-key="stokkodu">Parti No</vs-th>
                  <vs-th  sort-key="stokkodu">Stok No</vs-th>
                  <vs-th  sort-key="stokkodu">Stok Adı</vs-th>
                  <vs-th>Depo Adet</vs-th>
                  <vs-th>Sipariş Adet</vs-th>
                </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].partiNo2">
                        {{ data[indextr].partiNo2 }}
                      </vs-td>
                      <vs-td :data="data[indextr].urunKodu">
                        {{ data[indextr].urunKodu }}
                      </vs-td>
                      <vs-td :data="data[indextr].STOKADI">
                        {{ data[indextr].STOKADI }}
                      </vs-td>
                      <vs-td :data="data[indextr].depoAdet">
                        {{ data[indextr].depoAdet }}
                      </vs-td>
                      <vs-td :data="data[indextr].adet">
                        {{ data[indextr].adet }}
                      </vs-td>
                    </vs-tr>
                  </template>

              </vs-table>
            
        </vs-popup>   


         <vs-popup fullscreen  class="holamundo" title="Fatura Tekrar Yazdırma" :active.sync="popupFatura">
           
              <table>
                <tr>
                  <td><vs-input class="inputx" placeholder="Arama" @keyup.enter="faturaBul()" :ref="faturaBulOrderNumber" v-model="faturaBulOrderNumber" /></td>
                </tr>
              </table>
              <vs-table :data="listSonFaturalar">
                
                <template slot="thead">
                  <vs-th style="border:1px solid #000000; padding:12px"  sort-key="stokkodu">Sipariş No</vs-th>
                  <vs-th style="border:1px solid #000000; padding:12px"  sort-key="stokkodu">Müşteri Ad Soyad</vs-th>
                  <vs-th style="border:1px solid #000000; padding:12px"  sort-key="stokkodu">Tekrar Yazdır</vs-th>
                </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data" style="border:1px solid #000000">
                      
                     
                      <vs-td :data="data[indextr].urunKodu" style="border:1px solid #000000">
                        {{ data[indextr].orderNumber }}
                      </vs-td>
                      <vs-td :data="data[indextr].stokAdi" style="border:1px solid #000000">
                        {{ data[indextr].Column1 }} {{ data[indextr].shipFirstName }} {{ data[indextr].shipLastName }}
                      </vs-td>
                      
                      <vs-td :data="data[indextr].siparisAdet" style="border:1px solid #000000; text-align:center">
                        <vs-button @click="faturaCiktiEvrak(data[indextr].orderNumber)" color="success" type="filled">Çıktı Al</vs-button>
                      </vs-td>
                     
                    </vs-tr>
                   
                  </template>

              </vs-table>
             
        </vs-popup>


<iframe width="560" height="315" id="ciktiPdf" src="" frameborder="0"></iframe>
</div>

</template>

   


<script>
import vSelect from 'vue-select'
import state from '../../store/state'
import Store from '../../store/store'

export default {
  components: {
    'v-select': vSelect,
  },
  data () {
    return {
        options: [],
        optionsParti: [],
        pazaryeriTum:[],
        list: [],
        listSonFaturalar: [],
        listSiparis:[],
        sipariseGoreUrunListesi:[],
        progress:0,
        activePrompt:false,
        pazaryeriVal:'',
        partiVal:'',
        toplamParca:0,
        selected:{id: 0, label: 'Paketleme Firması'},
        selectedParti:{id: 0, label: 'Parti Nolar'},
        popupActive: false,
        popupFatura: false,
        popupActiveSiparis: false,
        popupActiveCikti:false,
        barkod:'',
        siparisBulOrderNumber:'',
        genelSiparisNo:'',
        genelKargoAdi:'',
        genelKargoNo:'',
        genelMusteri:'',
        hediyeMi:0,
        genelToplam:0,
        eklenenDeger:'',
        indext:0,
        indext1:0,
        urunResim:"",
        validated:1,
        validatedF:1,
        siparisToplamParca:0,
        eklenenToplamParca:0,
        askiDurumu:false,
        aski:0,
        imageLink:"",
        ciktiListesi:[],
        jsonD:'',
        dr:'',
        popupActiveFaturaCikti:false,
        receiptId:0,
        faturaNo:'',
        ilkOkuma:0,
        recId:0,
        total:0,
        faturaAranan:'',
        faturaBulOrderNumber:'',
          }
  },
  methods: {
    secilenSiparisSil(gelenOrder) {
           var vm = this
          var vs=this.$vs
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args = {pazaryeri: this.pazaryeriVal.trim(),orderNumber:gelenOrder,token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.secilenSiparisSil(args, function(err, result){
        if (result.siparisListeleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
          vm.veriler=JSON.parse(result.secilenSiparisSilResult)
      
      if (vm.veriler.response=='Ok') {
          vs.loading.close("#button-with-loading-partile > .con-vs-loading")
          vs.notify({
            title: 'Sipariş Silindi',
            text: "Sipariş Silindi",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position:'top-center'
          })

        } else {
          vs.notify({
            title: 'Sipariş Silinemedi',
            text: "Sipariş Silmede Hata Oluştu",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'error',
            position:'top-center'
          })
        }


        }
      
      
      })
      })
    },
    faturaOlustur() {
      

      var vm = this
      var vs = this.$vs
     vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      })

     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
     if (vm.recId==null) { vm.recId=1 }
    // alert(vm.genelSiparisNo+" - "+this.pazaryeriVal.trim()+" - "+Store.state.grupKod+" - "+Store.state.tokenId+" - "+vm.recId+" - "+Store.state.plasiyer)
      const args = {orderNumber:vm.genelSiparisNo,program: this.pazaryeriVal.trim(),grupKod:Store.state.grupKod,token:Store.state.tokenId,recId:vm.recId,EMPLOYEEID:Store.state.plasiyer}
    /*  const args1 = {orderNumber:vm.genelSiparisNo,program: this.pazaryeriVal.trim(),grupKod:Store.state.grupKod,token:Store.state.tokenId,recId:546610}
      const args2 = {orderNumber:vm.genelSiparisNo,program: this.pazaryeriVal.trim(),grupKod:Store.state.grupKod,token:Store.state.tokenId,recId:546622}
      const args3 = {orderNumber:vm.genelSiparisNo,program: this.pazaryeriVal.trim(),grupKod:Store.state.grupKod,token:Store.state.tokenId,recId:546621}
      const args4 = {orderNumber:vm.genelSiparisNo,program: this.pazaryeriVal.trim(),grupKod:Store.state.grupKod,token:Store.state.tokenId,recId:546620}
      const args5 = {orderNumber:vm.genelSiparisNo,program: this.pazaryeriVal.trim(),grupKod:Store.state.grupKod,token:Store.state.tokenId,recId:546619}*/

      soap.createClient(url, function(err, client){
      client.faturaYaz(args, function(err, result){
        if (result.faturaYazResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
          if (vm.recId==0) {
                 vs.loading.close("#button-with-loading > .con-vs-loading")
                 vs.notify({
                 title: 'Fatura',
                  text: vm.veriler.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
                  position:'top-center'
              })
             vm.validatedF=0
          } else {

          
           vm.veriler=JSON.parse(result.faturaYazResult)
           console.log(vm.veriler)
        if (vm.veriler.response=='Ok') {

           vs.loading.close("#button-with-loading > .con-vs-loading")

          vm.validatedF=0
          vm.recId=0
          vm.receiptId=vm.veriler.ReceiptId
          vm.faturaNo=vm.veriler.FaturaNo
          vs.loading.close("#button-with-loading-partile > .con-vs-loading")
          vs.notify({
            title: 'Fatura',
            text: "Fatura İşlemi Başarılı",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            position:'top-center'
          })
    document.getElementById("ciktiPdf").src=Store.state.printAddress+vm.receiptId.replace("'","")+"&Tr="+vm.pazaryeriVal;
    vm.imageLink=''
        //  window.open(Store.state.printAddress+vm.receiptId.replace("'",""), "_blank");    
      document.getElementById("barkodM").focus()
        vm.listeTemizle()
        vm.validated=1
                              } else {
              vs.loading.close("#button-with-loading > .con-vs-loading")
              vs.notify({
                title: 'Fatura',
                text: vm.veriler.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                position:'top-center'
              })
                                     }
        }
             }
      })
      })


    },
    faturaCiktiEvrak(order) {
document.getElementById("ciktiPdf").src=Store.state.printAddress+order+"&Tr="+this.pazaryeriVal;
    },
    faturaCikti() {
     
     var vm = this
              
                    const soap = require('soap')
                    const url = state.sistemAddress
                    const args = {token:Store.state.tokenId,program: this.pazaryeriVal,EMPLOYEEID:Store.state.plasiyer,faturaAranan:''}
                    soap.createClient(url, function(err, client){
                    client.sonFaturalar(args, function(err, result){
                      if (result.sonFaturalarResult=='-1') {
                        Store.dispatch('logout')
                        //this.$store.dispatch('login', payload)
                      } else {
                        //console.log(result.sonFaturalarResult)
                        vm.veriler=JSON.parse(result.sonFaturalarResult)
                        vm.listSonFaturalar=vm.veriler

                        vm.popupFatura=true
                      }
                    })
                    })

    },
    print () {
      // Pass the element id here
      this.$htmlToPaper('printMe');
    },
    indexbul(array, conditionFn) {
        const item = array.find(conditionFn)
        return array.indexOf(item)
      },
    ps1(text) {
      this.partiVal=text
    },
    ps(text) {
      const partiNumalari=[]
      this.pazaryeriVal=text
      partiNumalari.push('Tümü')
      this.pazaryeriTum.forEach(element => {
      if (text==element.pazaryeri) {
      partiNumalari.push(element.partiNo2)
      }
      })
      this.optionsParti=partiNumalari
    },
    ciktiAl() {
      
      const vs=this.$vs
      if (this.pazaryeriVal=='' || this.partiVal=='' || this.partiVal=='Tümü') {
                vs.notify({
            title: 'Paketleme',
            text: "Pazaryerini ve Parti Seçiniz",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
          } else {
                    var vm = this
                    const soap = require('soap')
                    const url = state.sistemAddress
                    const args = {pazaryeri: this.pazaryeriVal,partiNo:this.partiVal,token:Store.state.tokenId}
                    soap.createClient(url, function(err, client){
                    client.partiYaz(args, function(err, result){
                      if (result.partiYazResult=='-1') {
                        Store.dispatch('logout')
                        //this.$store.dispatch('login', payload)
                      } else {
                        vm.veriler=JSON.parse(result.partiYazResult)
                         vm.ciktiListesi=vm.veriler
                         vm.popupActiveCikti=true
                         vm.jsonD=vm.veriler
                       //console.log(vm.veriler)
                      }
                    
                    })
                    })
          }
    },
    
    secilenPartiUrunleri() {
     const vs=this.$vs
     
          if (this.pazaryeriVal=='' || this.partiVal=='') {
                vs.notify({
            title: 'Paketleme',
            text: "Pazaryerini ve Parti Seçiniz",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
          } else {
                    var vm = this
              
                    const soap = require('soap')
                    const url = state.sistemAddress
                    
                    const args = {pazaryeri: this.pazaryeriVal,partiNo:this.partiVal,token:Store.state.tokenId}
                    soap.createClient(url, function(err, client){
                    client.partiUrunleri(args, function(err, result){
                      if (result.partiUrunleriResult=='-1') {
                        Store.dispatch('logout')
                        //this.$store.dispatch('login', payload)
                      } else {
                        vm.veriler=JSON.parse(result.partiUrunleriResult)
                        vm.total=vm.veriler[0]["tt"]
                        vm.list=vm.veriler
                        


     

                        vm.popupActive=true
                      }
                    
                    })
                    })
          }
     



     
     
   },
   faturaBul() {
      var vm = this
              
                    const soap = require('soap')
                    const url = state.sistemAddress
                    const args = {token:Store.state.tokenId,program: this.pazaryeriVal,EMPLOYEEID:Store.state.plasiyer,faturaAranan:vm.faturaBulOrderNumber}
                    soap.createClient(url, function(err, client){
                    client.sonFaturalar(args, function(err, result){
                      if (result.sonFaturalarResult=='-1') {
                        Store.dispatch('logout')
                        //this.$store.dispatch('login', payload)
                      } else {
                        //console.log(result.sonFaturalarResult)
                        vm.veriler=JSON.parse(result.sonFaturalarResult)
                        console.log(vm.veriler)
                        vm.listSonFaturalar=vm.veriler

                        vm.popupFatura=true
                      }
                    })
                    })
   },
    siparisBul() {
      var vm = this
      
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args = {pazaryeri: this.pazaryeriVal.trim(),token:Store.state.tokenId,sayfa:0,orderNumber:this.siparisBulOrderNumber}
      soap.createClient(url, function(err, client){
      client.siparisListele(args, function(err, result){
        if (result.siparisListeleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
          vm.veriler=JSON.parse(result.siparisListeleResult)
      vm.listSiparis=vm.veriler
      vm.popupActiveSiparis=true
        }
      
      
      })
      })

   },
    siparisSec() {

     var vm = this
      
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args = {pazaryeri: this.pazaryeriVal.trim(),token:Store.state.tokenId,sayfa:0}
      soap.createClient(url, function(err, client){
      client.siparisListele(args, function(err, result){
        if (result.siparisListeleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
          vm.veriler=JSON.parse(result.siparisListeleResult)
      vm.listSiparis=vm.veriler
      vm.popupActiveSiparis=true
        }
      
      
      })
      })



     
     
   },
    barkodOku(gelenorder) {
    // alert(gelenorder)
      const vm = this
      const vs=this.$vs
      const kontrol=0
      if (vm.askiDurumu===true) { vm.aski=1 } else { vm.aski=0 }
     if (this.pazaryeriVal=='') {
        vs.notify({
            title: 'Paketleme',
            text: "Pazaryerini Seçiniz",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
          vm.kontrol=1
     } 
     if (this.partiVal=='') {
        vs.notify({
            title: 'Paketleme',
            text: "Parti Seçiniz",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            position:'top-center'
          })
          vm.kontrol=1
     }
     
     if (kontrol==0 && vm.sipariseGoreUrunListesi.length==0) {
          const soap = require('soap')
          const url = state.sistemAddress
         //console.log(this.pazaryeriVal.trim()+"**"+this.partiVal+"**"+vm.barkod+"**"+this.aski+"**"+gelenorder+"**"+Store.state.tokenId)
       
          const args = {pazaryeri: this.pazaryeriVal.trim(),partiNo:this.partiVal,barkod:vm.barkod,askiDurumu:this.aski,orderNumber:gelenorder,token:Store.state.tokenId}
          soap.createClient(url, function(err, client){
          client.partiUrun(args, function(err, result){
            if (result.partiUrunResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
            }
          vm.veriler=JSON.parse(result.partiUrunResult)
          const dm=[]
         // console.log(vm.veriler)
         const im=0
          for(vm.im=0;vm.im<vm.veriler.length;vm.im++) {
            if (vm.im==0) {
           //   alert("s")
               dm[vm.im]=vm.veriler[vm.im] 
               } else {
            let o=vm.indexbul(dm,item => item.barcode === vm.veriler[vm.im].barcode)
            //alert(o)
            if (o!=-1) {
              
              dm[o].quantity=dm[o].quantity+vm.veriler[vm.im].quantity
            } else {
              dm[vm.im]=vm.veriler[vm.im] 
            }
            }
          }
          vm.veriler=dm
         // console.log(vm.veriler)
          if (vm.veriler.response=='No') {
             vs.notify({
                title: 'Paketleme',
                text: "Okutulan Ürün Sipariş Listesinde Yok",
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                position:'top-center'
              })

          } else {


          vm.genelSiparisNo=vm.veriler[0].orderNumber
          vm.genelKargoAdi=vm.veriler[0].cargoProviderName
          vm.genelKargoNo=vm.veriler[0].cargoTrackingNumber
          vm.genelToplam=vm.veriler[0].grossAmount
          vm.genelMusteri=vm.veriler[0].shipFirstName+" "+vm.veriler[0].shipLastName
          vm.hediyeMi=vm.veriler[0].hediyeMi
          vm.recId=vm.veriler[0].siparisKayit
          vm.sipariseGoreUrunListesi=vm.veriler
         
          vm.indext = vm.indexbul(vm.sipariseGoreUrunListesi, item => item.barcode === vm.barkod)
           
          if (vm.indext==-1) {
                vm.indext = vm.indexbul(vm.sipariseGoreUrunListesi, item => item.merchantSku === vm.barkod)   
                
            }
           // alert(vm.veriler[vm.indext].merchantSku)
            vm.imageShow(vm.veriler[vm.indext].merchantSku)
            if (vm.ilkOkuma==0) {
          vm.sipariseGoreUrunListesi[vm.indext].eklenen=1
           vm.eklenenToplamParca=1
            } else {
          vm.sipariseGoreUrunListesi[vm.indext].eklenen=0
          vm.ilkOkuma=0
            }
          vm.siparisToplamParca=vm.sipariseGoreUrunListesi.reduce((sum, item) => sum + item.quantity, 0)
         
          if (vm.eklenenToplamParca===vm.siparisToplamParca) {
                vm.validated=0
              }


          }
         
          vm.barkod="";
          document.getElementById("barkodM").focus()

          //vm.$refs.barkod.focus()
         // vm.$nextTick(() => vm.barkod.focus())
          //vm.vSelect.barkod.focus();
          
          })
          })
     } else {
      
       vm.indext=vm.indexbul(vm.sipariseGoreUrunListesi, item => item.barcode === vm.barkod)
            if (vm.indext==-1) {
              
                vm.indext1 = vm.indexbul(vm.sipariseGoreUrunListesi, item => item.merchantSku === vm.barkod)      
            }
            
            if (vm.indext==-1) { vm.indext=vm.indext1
                
            }
         // alert(vm.indext)
         // alert(vm.sipariseGoreUrunListesi[vm.indext].eklenen)
            
            if (vm.indext==-1) {
                vs.notify({
                title: 'Paketleme',
                text: "Okutulan Ürün Sipariş Listesinde Yok 1",
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                position:'top-center'
              })

        } else {
            vm.eklenenDeger=0;  
            vm.eklenenDeger=vm.sipariseGoreUrunListesi[vm.indext].eklenen
            vm.imageShow(vm.sipariseGoreUrunListesi[vm.indext].merchantSku)
            if (vm.eklenenDeger==undefined) { vm.eklenenDeger=0 }
            if ((parseInt(vm.sipariseGoreUrunListesi[vm.indext].quantity)>parseInt(vm.eklenenDeger) ) ) {
              vm.sipariseGoreUrunListesi[vm.indext].eklenen=parseInt(vm.eklenenDeger)+1
              vm.eklenenToplamParca=Number(vm.eklenenToplamParca)+1
              if (vm.eklenenToplamParca===vm.siparisToplamParca) {
                vm.validated=0
              }
              } else {
                vs.notify({
                title: 'Paketleme',
                text: "Sipariş Adetinden Fazla Ürün Okutmayınız",
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'warning',
                position:'top-center'
              })
              }

        }
      
        vm.barkod="";
        //vm.vSelect.barkod.focus();
     }

     //alert(this.barkod)
   },
    imageShow(sku) {
      var vm = this
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {stokKodu: sku,token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.resimGoruntule(args, function(err, result){
        if (result.resimGoruntuleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
            }
      vm.veriler=JSON.parse(result.resimGoruntuleResult)
      if (vm.veriler.length>0) {
       
      vm.imageLink=vm.veriler[0]["STOCKPICTURE"]
      }
      })
      })
   },
    askiyaAl() {
          const vs=this.$vs
          const vm=this
          const soap = require('soap')
          const url = state.sistemAddress
          const args = {orderNumber: this.genelSiparisNo,token:Store.state.tokenId}
          soap.createClient(url, function(err, client){
          client.siparisiAskiyaAl(args, function(err, result){
            if (result.siparisiAskiyaAlResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
            }
          vm.veriler=JSON.parse(result.siparisiAskiyaAlResult)
              vs.notify({
                title: 'Paketleme',
                text: "Sipariş Askıya Alındı",
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success',
                position:'top-center'
              })
          })
          })

          

   },
    tekrarIslemeAl(orderNumber,merchantSku,partiNo){

      var vm = this
      
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args = {pazaryeri: this.pazaryeriVal.trim(),token:Store.state.tokenId,orderNumber:orderNumber}
      soap.createClient(url, function(err, client){
      client.tekrarIslemeAl(args, function(err, result){
        if (result.siparisListeleResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
        } else {
         vm.siparisHazirla(orderNumber,merchantSku,partiNo)
        }
      
      
      })
      })

   },
    siparisHazirla(orderNumber,merchantSku,partiNo) {
    // alert(orderNumber+" "+merchantSku+" "+partiNo)
     this.partiVal=partiNo
     this.barkod=merchantSku
     this.ilkOkuma=1
     this.barkodOku(orderNumber.trim())
     this.popupActiveSiparis=false
   },
   morhipoToplu() {


       var vm = this
      
     const soap = require('soap')
      const url = state.sistemAddress
     // alert(this.pazaryeriVal)
      const args = {program: this.pazaryeriVal.trim()}
      soap.createClient(url, function(err, client){
      client.MorhipoPaketlemeToplu(args, function(err, result){
       
          vm.veriler=JSON.parse(result.MorhipoPaketlemeTopluResult)
    
      
      
      
      })
      })



   },
    listeTemizle() {
          this.sipariseGoreUrunListesi=[]
          this.validated=1
          this.eklenenToplamParca=0
   }
          },
  beforeMount(){
  //  console.log(Store.state.UserId)
      var vm = this
      //document.getElementById("barkodM").focus()
      const soap = require('soap')
      const url = state.sistemAddress
      const args = {token:Store.state.tokenId}
      soap.createClient(url, function(err, client){
      client.partiListesi(args, function(err, result){
        if (result.partiListesiResult=='-1') {
          Store.dispatch('logout')
          //this.$store.dispatch('login', payload)
            }
      vm.veriler=JSON.parse(result.partiListesiResult)
      const pazaryerleri = [...new Set(vm.veriler.map(x=>x.pazaryeri))]
      vm.pazaryeriTum=vm.veriler
      vm.options=pazaryerleri
      })
      })
              }
  
}

</script>
<style lang="scss" scoped>
.mb-base { margin-bottom: 0.75rem!important;}
.list-view-item {
    .item-name, .item-description {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .item-name {
        -webkit-line-clamp: 2;
    }

    .item-description {
        -webkit-line-clamp: 5;
    }

    .grid-view-img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        transition: .35s;
    }

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 4px 25px 0px rgba(0,0,0,.25);

        .grid-view-img{
            opacity: 0.9;
        }
    }
}
</style>
